//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//

import { mapState } from 'vuex';
import { selectRandomElements } from '@/helpers/random.js'
import userChecks from '~/mixins/userChecks';
import activateTypeFilter from '~/mixins/ResourceFilterFunctions/type.js';
import activateSortFilter from '~/mixins/ResourceSortFunctions/sort.js';
export default {
  name: 'videosCollection',
  mixins: [userChecks, activateTypeFilter, activateSortFilter],
  async fetch() {
    await Promise.all([
      this.$store.dispatch('bannerStore/getBanner', 'sexfilmsCollection'),
      this.$store.dispatch('pagesStore/getPage', 'sexfilms'),
    ]);
  },
  beforeRouteEnter(to, from, next) {
    if (to.query.filter && to.query.filter === 'direct') {
      next((vm) => {
        vm.activateTypeFilter('products', 'direct', 'Direct');
      });
    } else if (to.query.sort && to.query.sort === 'published_at') {
      next((vm) => {
        vm.activateSortFilter('sort', 'published_at', 'DESC', 'Meest recent', vm.queries.videos);
      });
    } else if (to.query.sort && to.query.sort === 'recommended_at') {
      next((vm) => {
        vm.activateSortFilter('sort', 'recommended_at', 'DESC', 'Aanbevolen', vm.queries.videos);
      });
    } else {
      next();
    }
  },
  mounted() {
    console.log(123)
    this.loadRandomStuff();
    if(this.$route.query.sort || this.$route.query.filter){
      var self = this;
      // this need to change. Sliders make filter inactive but sliders should not even load if route has query
      setTimeout(function () {
        self.$store.commit('filtersStore/toggleFilterState', true);
      }, 1000);
    }
  },
  watch: {
    '$route.query.sort'(newVal, oldVal) {
      this.activateSortFilter('sort', newVal, 'DESC', 'Aanbevolen', this.queries.videos);
    },
    'filter.active'(newVal, oldVal) {
      console.log(newVal);
      if (newVal && window) {
        window.scrollTo({
          top: 0,
          behavior: 'smooth'
        });
      }
    }
  },
  components: {
    dummyCollection: () => import('~/components/content/dummy/collection.vue'),
    filters: () => import('~/components/filters/filtermodule.vue'),
    videoItem: () => import('~/components/content/video/video.vue'),
    plannedVideos: () => import('~/components/home/planned_sexfilms.vue'),
    banner: () => import('~/components/banner.vue'),
    newrecurringVideos: () => import('~/components/home/newest_recurring.vue'),
    newestVideos: () => import('~/components/home/newest_videos.vue'),
    freeVideos: () => import('~/components/home/free_videos.vue'),
    topVideos: () => import('~/components/home/top_videos.vue'),
    randomVideos: () => import('~/components/home/random_videos.vue'),
    categoryVideos: () => import('~/components/home/category_videos.vue'),
    modelVideos: () => import('~/components/home/model_videos.vue'),
    swiperFreeVideos: () => import('~/components/home/swiper_free_videos.vue'),
    about: () => import('~/components/about_section.vue'),
    swiperNewVideos: () => import('~/components/home/swiper_new_videos.vue'),
    Loadmore: () => import('~/components/loadmore.vue'),
  },
  head() {
    return {
      title: this.pages.sexfilms ? this.pages.sexfilms.seo.title : 'Sexfilms: Nederlands - Direct - Geil - Gratis | Meiden van Holland',
      meta: [
        { hid: 'title', name: 'title', content: this.pages.sexfilms ? this.pages.sexfilms.seo.title : 'Sexfilms: Nederlands - Direct - Geil - Gratis | Meiden van Holland' },
        { hid: 'og:title', name: 'og:title', content: this.pages.sexfilms ? this.pages.sexfilms.seo.title : 'Sexfilms: Nederlands - Direct - Geil - Gratis | Meiden van Holland' },
        { hid: 'description', name: 'description', content: this.pages.sexfilms ? this.pages.sexfilms.seo.description : 'De meest geile Sexfilms van Holland - Geil op een gratis sexfilm, stream sexfilms onbeperkt of kom met een nieuwe exclusieve sexfilm - 100% Nederlands XXX'},
        { hid: 'og:description', name: 'og:description', content: this.pages.sexfilms ? this.pages.sexfilms.seo.description : 'De meest geile Sexfilms van Holland - Geil op een gratis sexfilm, stream sexfilms onbeperkt of kom met een nieuwe exclusieve sexfilm - 100% Nederlands XXX' },
        { hid: 'og:url', name: 'og:url', content: process.env.FE_URL + '/sexfilms'},
        { hid: 'keywords', name: 'keywords', content: this.pages.sexfilms ? this.pages.sexfilms.seo.keywords : 'sexfilms, sexfilm, sex films, sex film, gratis, Nederlands, Hollands'},
      ]
    }
  },
  computed: {
    ...mapState({
      queries: ({ resourcesStore: {queries} }) => queries,
      pages: ({ pagesStore: {pages} }) => pages,
      videos: ({ resourcesStore: {videos} }) => videos,
      loading: ({ resourcesStore: {loading} }) => loading,
      filter: ({ filtersStore: { filter } }) => filter,
      randomCategories: ({ resourcesStore: { randomCategories } }) => randomCategories,
      randomModels: ({ resourcesStore: { randomModels } }) => randomModels,
    }),
  },
  data() {
    return {
      selectedRandomCategories: {},
      selectedRandomModels: {},
      show_more: {
        current: 0,
        total: 2,
      },
    }
  },
  methods: {
    async onShowMoreClick() {
      this.show_more.current++;
    },
    async loadRandomStuff() {
      await Promise.all([
        this.$store.dispatch('resourcesStore/getResources', this.queries.randomCategories),
        this.$store.dispatch('resourcesStore/getResources', this.queries.randomModels),
      ]);
      this.selectedRandomCategories = selectRandomElements(
        'categories', 
        4, 
        this.randomCategories.data
        );
      this.selectedRandomModels = selectRandomElements(
        'models', 
        4, 
        this.randomModels.data
        );
    },
  }
};
